import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';
import { CustomFieldRating } from './CustomFieldRating';

export const TitleContainer = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex items-center gap-1 py-1', className)} {...props} />
);

export const ReadonlyContainer = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    className={cn(
      'flex items-center gap-0.5 rounded-md border border-border-neutral-subtle p-1 [&_div]:flex',
      className,
    )}
    {...props}
  />
);

export const HoverButtonsContainer = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex grow justify-end gap-1', className)} {...props} />
);

export const CustomRating = ({ className, ...props }: ComponentProps<typeof CustomFieldRating>) => (
  <CustomFieldRating className={cn('text-icon-brand-primary', className)} {...props} />
);

export const FieldRating = ({ className, ...props }: ComponentProps<typeof CustomFieldRating>) => (
  <CustomFieldRating className={cn('text-icon-neutral-primary', className)} {...props} />
);

export const FlexDiv = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex items-center gap-2', className)} {...props} />
);

export const PercentContainer = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    className={cn(
      'w-4/5 overflow-hidden rounded-sm border border-border-neutral-subtle',
      className,
    )}
    {...props}
  />
);

export const getPercentBackgroundClass = (percent: number) => {
  if (percent === 0) return undefined;
  if (percent >= 80) return 'bg-bg-success-subtle';
  if (percent >= 60) return 'bg-bg-warning-subtle';
  if (percent >= 30) return 'bg-bg-warning';
  return 'bg-bg-error';
};

export const PercentBar = ({
  percent,
  className,
  style,
  ...props
}: ComponentProps<'div'> & { percent?: number }) => (
  <div
    className={cn(
      'flex h-7 items-center justify-center text-center',
      getPercentBackgroundClass(percent ?? 0),
      className,
    )}
    style={{ width: `${percent ?? 100}%`, ...style }}
    {...props}
  />
);
